module.exports = __webpack_public_path__ + "img/unauthorized.7a833dfe.png";